import { Avatar, SxProps, Theme } from '@mui/material';
import React from 'react';
import { AuthUser, UsersDTO } from '../../../redux/identity/identityTypes';
import { getUserName } from './utils';

export interface UserAvatarProps {
	user: AuthUser | UsersDTO | null | undefined;
	size?: number;
	sx?: SxProps<Theme>;
}

export const getUserInitials = (
	user: AuthUser | UsersDTO | null | undefined,
): string => {
	if (!user) return '?';
	if ('Name' in user && user.Name) {
		return user.Surname
			? `${user.Name.charAt(0)}${user.Surname.charAt(0)}`
			: user.Name.charAt(0);
	}
	if ('name' in user && user.name) {
		return user.name.charAt(0).toUpperCase();
	}
	return '?';
};

const getAvatarSrc = (user: AuthUser | UsersDTO | null | undefined): string => {
	if (user && 'ProfileImageBase64' in user && user.ProfileImageBase64) {
		return `data:image/png;base64,${user.ProfileImageBase64}`;
	}
	return '';
};

const UserAvatar: React.FC<UserAvatarProps> = ({ user, size = 64, sx }) => {
	const userName = getUserName(user);
	const initials = getUserInitials(user);
	const avatarSrc = getAvatarSrc(user);

	return (
		<Avatar
			sx={{
				width: size,
				height: size,
				bgcolor: (th) => th.palette.kemek.lightGray,
				color: (th) => th.palette.kemek.darkestGray,
				fontSize: size > 40 ? '20px' : '14px',
				fontWeight: 500,
				...sx,
			}}
		>
			{avatarSrc ? (
				<img
					src={avatarSrc}
					alt={userName}
					style={{ width: '100%', height: '100%', objectFit: 'cover' }}
				/>
			) : (
				initials
			)}
		</Avatar>
	);
};

export default UserAvatar;
